import { useMutation, UseMutationOptions } from 'react-query';

import type { BuildFactFiltersWithNLResponseDto } from '../../../../backend/src/case/fact/dto/build-fact-filters-with-nl.dto.js';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface BuildFactFiltersWithNLParams {
  caseId: string;
  query: string;
}

export const useBuildFactFiltersWithNL = (
  options?: UseMutationOptions<BuildFactFiltersWithNLResponseDto, Error, BuildFactFiltersWithNLParams>,
) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation({
    mutationFn: async ({ caseId, query }: BuildFactFiltersWithNLParams) => {
      const response = await fetch(
        `${APIBaseChronos}/api/case/${caseId}/fact/build-filters-nl`,
        getFetchConfig({
          method: FetchMethod.POST,
          data: { query },
        }),
      );

      if (!response.ok) {
        throw new Error('Failed to build fact filters with natural language');
      }

      return await response.json();
    },
    ...options,
  });
};
